import DOMPurify from 'isomorphic-dompurify';

export const sanitizeSeoSectionHtml = (html: string) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['section', 'h2', 'p', 'div', 'br', 'a'],
    ALLOWED_ATTR: ['href', 'rel', 'target'],
  }).toString();
};
